import AddIcon from '@atlaskit/icon/core/add';
import { Inline } from '@atlaskit/primitives';
import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import entryIcon from '../../assets/entry_icon.svg';
import { messages } from '../../i18n';

export interface DatabaseEntryPickerOptionProps {
  isCreate: boolean;
  label: string;
}

const DatabaseEntryPickerOption: FunctionComponent<DatabaseEntryPickerOptionProps> = ({
  isCreate,
  label
}) => {
  const { formatMessage } = useIntl();

  return (
    <Inline alignBlock="center" space="space.100">
      {isCreate ? (
        <AddIcon
          size="small"
          label={formatMessage(messages['reference-entry-picker-option.add-icon-label'])}
        />
      ) : (
        <img src={entryIcon} alt="" />
      )}
      {label}
    </Inline>
  );
};

export default DatabaseEntryPickerOption;
